// assets
import {
    IconSettings,
    IconCoin,
    IconMail,
    IconSettingsAutomation,
} from '@tabler/icons-react'

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const other = {
    title: 'Device Settings',
    caption: 'You can change your appliance information, access and tariffs.',
    id: 'other',
    type: 'group',
    children: [
        {
            id: 'device-settings',
            title: 'Device Settings',
            type: 'item',
            url: '/device-settings',
            icon: IconSettings,
            breadcrumbs: false,
        },
        {
            id: 'automation',
            title: 'Automation',
            type: 'item',
            url: '/automation',
            icon: IconSettingsAutomation,
            breadcrumbs: false,
            disabled: false,
        },
        {
            id: 'tariffs',
            title: 'Tariffs',
            type: 'item',
            url: '/tariffs',
            icon: IconCoin,
            breadcrumbs: false,
        },
        // {
        //     id: 'email-notifications',
        //     title: 'Email Notifications',
        //     type: 'item',
        //     url: '/email-notifications',
        //     icon: IconMail,
        //     breadcrumbs: false,
        //     disabled:
        //         import.meta.env.VITE_APP_ENV !== 'DEVELOPMENT' ? true : false,
        // },
    ],
}

export default other
